module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isInPrintMode || _vm.eventsFiltered.length > 0) ? _c('ul', {
    ref: "d_weekplan",
    staticClass: "weekplan box text-dark",
    class: {
      'weekplan--editable': !_vm.isReadOnly
    }
  }, [(!_vm.isInViewport) ? _c('div', {
    staticClass: "weekplan-placeholder box",
    style: (_vm.placeholderHeight)
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].weekplan))]), _vm._v(" "), (_vm.isWeekplanHasLesson) ? _c('Loader', {
    attrs: {
      "bg-color": "#fff"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isInViewport) ? [_c('div', {
    ref: "d_eip",
    staticClass: "deip-holder",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.activeEvent) ? _c('EIP', {
    attrs: {
      "activeEIP": _vm.activeEIP,
      "lesson": _vm.activeEvent,
      "noteType": _vm.activeNoteType,
      "isUploadFile": false,
      "isClosingWithoutSaving": _vm.isClosingWithoutSaving,
      "isSaving": _vm.isSavingEIP
    },
    on: {
      "changed": _vm.setIsEditorChangedWithoutSave,
      "close": _vm.closeEip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('h2', {
    staticClass: "marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].weekplan))]), _vm._v(" "), (_vm.weekNote !== undefined && _vm.calendar && _vm.calendar.type === 'klass') ? _c('div', {
    staticClass: "week_note"
  }, [(_vm.isReadOnly) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.weekNote)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isReadOnly) ? _c('div', {
    staticClass: "weekplan--grid__note",
    class: [{
      'weekplan--grid__note--open': _vm.activeEventId === _vm.calendar.id + '_' + 'weeknote'
    }, {
      'weekplan--grid__note--empty': _vm.weekNote.length < 1
    }],
    attrs: {
      "id": _vm.calendar.id + '_' + 'weeknote'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setActiveEip(null, 'weeknote', _vm.calendar.id + '_' + 'weeknote', $event)
      }
    }
  }, [(_vm.activeEventId !== _vm.calendar.id + '_' + 'weeknote') ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.weekNote)
    }
  }) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isWeekplanHasLesson) ? _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].no_events_this_week))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsWithinDays), function(day, key) {
    return (day.lessons.length !== 0) ? _c('li', {
      key: day.date,
      staticClass: "weekplan__day-change"
    }, [_c('h3', [_vm._v(_vm._s(_vm.filterLocaleDate(day.date)))]), _vm._v(" "), _c('div', {
      staticClass: "weekplan__grid day-change__headline"
    }, [_c('p', {
      staticClass: "weekplan__grid__title"
    }, [(_vm.calendar.type !== 'other') ? void 0 : _vm._e()], 2), _vm._v(" "), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].learning_goal))] : _vm._e(), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].meeting_purpose))] : _vm._e()], 2), _vm._v(" "), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].content))] : _vm._e(), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].agenda))] : _vm._e()], 2), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].pupil_preparation))] : _vm._e(), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].decisions_and_resume))] : _vm._e()], 2), _vm._v(" "), _c('p', [(_vm.calendar.type !== 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].teacher_notes))] : _vm._e()], 2), _vm._v(" "), (_vm.calendar.type === 'other') ? [_vm._v(_vm._s(_vm.i18n[_vm.locale].internal_notes))] : _vm._e()], 2), _vm._v(" "), _c('ul', _vm._l((day.lessons), function(event) {
      return _c('li', {
        key: event.event_id,
        staticClass: "box week-plan__lesson__note weekplan__grid",
        class: {
          'lesson__notes--readonly': _vm.isReadOnly
        },
        style: ({
          borderColor: event.color
        })
      }, [_c('div', {
        staticClass: "weekplan__grid__title"
      }, [_c('span', {
        staticClass: "bold"
      }, [_vm._v(_vm._s(event.title))]), (event.group) ? _c('span', [_vm._v(", " + _vm._s(event.group))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timeStamp")(event.start)) + " - " + _vm._s(_vm._f("timeStamp")(event.end))), _c('br')])]), _vm._v(" "), _c('div', {
        staticClass: "weekplan--grid__note",
        class: [{
          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'learning_goal'
        }, {
          'weekplan--grid__note--empty': event.learning_goal.length < 1
        }],
        attrs: {
          "id": event.event_id + '_' + 'learning_goal'
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.setActiveEip(event, 'learning_goal', event.event_id + '_' + 'learning_goal', $event)
          }
        }
      }, [(_vm.activeEventId !== event.event_id + '_' + 'learning_goal') ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(event.learning_goal)
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "weekplan--grid__note",
        class: [{
          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'description'
        }, {
          'weekplan--grid__note--empty': event.description.length < 1
        }],
        attrs: {
          "id": event.event_id + '_' + 'description'
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.setActiveEip(event, 'description', event.event_id + '_' + 'description', $event)
          }
        }
      }, [(_vm.activeEventId !== event.event_id + '_' + 'description') ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(event.description)
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "weekplan--grid__note",
        class: [{
          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'notes_for_students'
        }, {
          'weekplan--grid__note--empty': event.notes_for_students.length < 1
        }],
        attrs: {
          "id": event.event_id + '_' + 'notes_for_students'
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.setActiveEip(event, 'notes_for_students', event.event_id + '_' + 'notes_for_students', $event)
          }
        }
      }, [(_vm.activeEventId !== event.event_id + '_' + 'notes_for_students') ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(event.notes_for_students)
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "weekplan--grid__note",
        class: [{
          'weekplan--grid__note--open': _vm.activeEventId === event.event_id + '_' + 'teacher_notes'
        }, {
          'weekplan--grid__note--empty': event.teacher_notes.length < 1
        }],
        attrs: {
          "id": event.event_id + '_' + 'teacher_notes'
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.setActiveEip(event, 'teacher_notes', event.event_id + '_' + 'teacher_notes', $event)
          }
        }
      }, [(_vm.activeEventId !== event.event_id + '_' + 'teacher_notes') ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(event.teacher_notes)
        }
      }) : _vm._e()])])
    }), 0)]) : _vm._e()
  })] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-540947a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Weekplan/DWeekplan.vue
// module id = 1601
// module chunks = 1